import React, { Component } from 'react';
import './HeaderCarousel.css';
import CarouselItem from './CarouselItem/CarouselItem';
import NextButton from './NextButton/NextButton';
import PrevButton from './PrevButton/PrevButton';

class HeaderCarousel extends Component {
  state = {};
  render() {
    return (
      <header>
        <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
          <ol className="carousel-indicators">
            <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active" />
            <li data-target="#carouselExampleIndicators" data-slide-to="1" />
            <li data-target="#carouselExampleIndicators" data-slide-to="2" />
          </ol>
          <div className="carousel-inner" role="listbox">
            <CarouselItem active backgroundImage="OutsideAR.jpg" title="Motion-AR" description="Capture your movement on the fly!" />
            <CarouselItem
              backgroundImage="InsideOge.jpg"
              title="Record it!"
              description="Capture movement with advanced AI body tracking "
            />
            <CarouselItem
              backgroundImage="InsideAR.jpg"
              title="Replay it!"
              description="And Replay it in Augmented Reality on any Avatar!"
            />
          </div>
          <PrevButton />
          <NextButton />
        </div>
      </header>
    );
  }
}

export default HeaderCarousel;
